import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { _t } from 'utils';
import DirectionArrow from './direction-arrow';
import Action from './action';

export default ({ dcId, nicId, serverId }) => {
  const directionOptions = [
    ['INGRESS', <DirectionArrow type="INGRESS" />],
    ['EGRESS', <DirectionArrow type="EGRESS" />],
    ['BIDIRECTIONAL', <DirectionArrow type="BIDIRECTIONAL" />],
  ];

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'action',
      title: 'Action',
      type: 'dropdown',
      options: [
        ['ACCEPTED', <Action type="ACCEPTED" />],
        ['REJECTED', <Action type="REJECTED" />],
      ],
    },
    {
      name: 'direction',
      title: 'Direction',
      type: 'dropdown',
      options: directionOptions,
    },
    {
      name: 'bucket',
      type: 'text',
      title: 'Bucket Name',
    },
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, min: 3 },
    { name: 'action', type: VALIDATION.REQUIRED },
    { name: 'direction', type: VALIDATION.REQUIRED },
    { name: 'bucket', type: VALIDATION.REQUIRED },
    { name: 'bucket', type: VALIDATION.VARIABLE },
  ];

  const onSave = (properties) => {
    actions.nic.flowlogAdd({
      dcId, nicId, serverId, properties,
    });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={{}}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
    />
  );
};
